<!--赖传峰-->
<!--2022/1/24-->
<!--eslint-disable max-len-->
<template>
  <DriveFeatureSVGSlot>
    <rect
      fill="black"
      height="33.6"
      opacity="0.01"
      width="33.6"
      x="19.1992"
      y="19.2002"
    />
    <rect
      fill="black"
      height="40.8"
      opacity="0.01"
      width="40.8"
      x="15.5996"
      y="15.6001"
    />
    <path
      :fill="props.color"
      clip-rule="evenodd"
      d="M34.795 21.4354C29.2028 21.6297 24.7049 26.063 24.5078 31.5751L24.506 31.6951L24.3573 31.7469C20.5657 33.1314 17.9307 36.726 17.9307 40.8573C17.9307 46.2223 22.3432 50.5716 27.7862 50.5716H44.2122C49.6553 50.5716 54.0678 46.2223 54.0678 40.8573L54.061 40.4931C53.8893 35.901 50.4838 32.1231 46.0229 31.3066L45.8302 31.2758L45.828 31.201C45.437 25.7396 40.8182 21.4287 35.1779 21.4287L34.795 21.4354Z"
      fill-rule="evenodd"
    />
    <path
      d="M30.7549 36.5829L33.0863 34.2515V42.4115"
      stroke="white"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2.4"
    />
    <path
      d="M40.0801 40.0802L37.7486 42.4116V34.2516"
      stroke="white"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2.4"
    />
  </DriveFeatureSVGSlot>
</template>

<script
  lang="ts"
  setup
>
import IconPropsType from '@/components/icons/iconPropsType'
import DriveFeatureSVGSlot from './PremiumRightsSVGSlot.vue'

const props = defineProps({ color: IconPropsType.color })
</script>
